export const merchantOperatingHoursMobileTimeInputClass =
  'min-w-0 flex-1 rounded-full border-0 bg-merchant-input px-3 py-2.5 text-center text-sm font-medium text-merchant-ink outline-none focus:ring-2 focus:ring-merchant-primary/15'
